module.exports = __webpack_public_path__ + "media/img/Landing_Page/logos/20-93cd5ae930a4f85369ea069efbd397a4.jpg";